import request from 'assets/js/http';
export function unCreateList(data) {
  return request({
    url: '/coin/unCreateList',
    method: 'post',
    data: data
  });
}
export function hideCoin(data) {
  return request({
    url: '/coin/hide',
    method: 'post',
    data: data
  });
}
export function createCoin(data) {
  return request({
    url: '/coin/create',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data: data
  });
}
export function coinList(data) {
  return request({
    url: '/coin/list',
    method: 'post',
    data: data
  });
}
